// src/features/agent-builder/components/McpInfoBox.tsx
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { renderIcon } from '@dopomogai/utils';
import clsx from 'clsx';

export const McpInfoBox: React.FC = () => {
  const { t } = useTranslation('agentBuilder');

  return (
    <div className="relative group mt-8 cursor-default"> {/* cursor-default if not clickable */}
      {/* Shadow Element - Appears on hover */}
      <div
        className={clsx(
          "absolute inset-0 rounded-xl bg-black", // Shadow is black
          "transition-all duration-150 ease-out", // Transition for smooth appearance & transform
          // Initially no translation, shadow revealed by content moving
          "group-hover:translate-x-1 group-hover:translate-y-1" // Shadow translates into view
        )}
        aria-hidden="true"
      />

      {/* Content Element - Lifts on hover */}
      <div
        className={clsx(
          "relative p-6 bg-slate-800 text-slate-200 rounded-xl",
          "border-2 border-slate-500", // Contrasting border on dark bg
          "transition-transform duration-150 ease-out", // Transition for smooth lift
          "group-hover:-translate-x-1 group-hover:-translate-y-1" // Content lifts
        )}
      >
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 pt-0.5 text-sky-400">
            {renderIcon('network', { size: 32, strokeWidth: 1.5 })}
          </div>
          <div className="flex-grow">
            <h3 className="text-lg font-semibold text-white">
              {t('step3.mcp.title')}
            </h3>
            <p className="mt-1.5 text-sm text-slate-300 leading-relaxed">
              <Trans i18nKey="step3.mcp.description" ns="agentBuilder">
                All tools connect to your agent using the <strong className="text-sky-300">Model Context Protocol (MCP)</strong>, the open standard for AI, ensuring reliable and scalable interactions.
              </Trans>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};